import React from 'react';
import { useTranslate } from '../TranslationText';
import FormRadio from './FormRadio';

/**
 * Yes/No radio button pair — reusable shorthand for boolean fields.
 * Wraps FormRadio with pre-configured Yes (true) / No (false) options.
 *
 * @param {string} name - Form field name
 * @param {string} label - Group label
 * @param {boolean} required - Show required indicator
 * @param {boolean} disabled - Disable radios
 */
export default function FormYesNo({ name, label, required, disabled }) {
    const { translate } = useTranslate();

    const options = [
        { text: translate('web.yes', 'Yes'), value: true },
        { text: translate('web.no', 'No'), value: false },
    ];

    return (
        <FormRadio
            name={name}
            label={label}
            options={options}
            required={required}
            disabled={disabled}
        />
    );
}
